import _get from 'lodash/get';
import { Department, Intervention, Task, Team } from 'graphql-common';
import DepartmentFieldNames from '@lib/enums/fieldNames/departmentFieldNames';
import getFullName from '@lib/utils/getFullName';

export default function getDepartmentDefaultValuesFromQueryData(
  data: Department | undefined,
  membersIds: { id: string }[],
  accessGroups: Team[],
  linkedTasks: Task[],
  linkedInterventions: Intervention[],
) {
  const parent = data?.parent;
  const manager = data?.manager;
  return {
    [DepartmentFieldNames.Name]: data?.name || '',
    [DepartmentFieldNames.Description]: data?.description || '',
    [DepartmentFieldNames.Color]: data?.color
      ? { value: _get(data, 'color', null) }
      : undefined,
    [DepartmentFieldNames.ParentDepartment]: parent
      ? {
          value: parent.id,
          label: parent.name,
          data: { path: parent.path },
        }
      : null,
    [DepartmentFieldNames.Manager]: manager
      ? {
          value: manager.id,
          label: getFullName(manager),
          data: manager,
        }
      : null,
    [DepartmentFieldNames.Members]:
      membersIds?.length > 0
        ? membersIds.map(({ id }) => ({ value: id }))
        : null,
    [DepartmentFieldNames.AccessGroups]: accessGroups?.length
      ? accessGroups.map(({ id, name, color }) => ({
          value: id,
          label: name,
          color,
        }))
      : null,
    [DepartmentFieldNames.Tasks]: linkedTasks?.length
      ? linkedTasks.map(({ id, groupKey, name }) => ({
          value: groupKey ?? id,
          label: name,
        }))
      : null,
    [DepartmentFieldNames.Interventions]: linkedInterventions?.length
      ? linkedInterventions.map(({ id, name, code }) => ({
          value: id,
          label: code ? `${code} — ${name}` : name,
        }))
      : null,
    // Custom renders
    [DepartmentFieldNames.BasicInformationTitle]: null,
    [DepartmentFieldNames.OrganizationStructureTitle]: null,
    [DepartmentFieldNames.ResultingHierarchy]: null,
    [DepartmentFieldNames.MembersAccessTitle]: null,
    [DepartmentFieldNames.MembersList]: null,
    [DepartmentFieldNames.AccessGroupsList]: null,
    [DepartmentFieldNames.LinkedTasksTitle]: null,
    [DepartmentFieldNames.LinkedInterventionsTitle]: null,
  };
}
